import { connect } from "react-redux";
import get from "lodash/get";

import {
  handleClearFilter as onHandleClearFilter,
  handleChangeStoreCarsFilter as onHandleChangeStore,
  confirmCarsFilter as onConfirmCarsFilter,
} from "../../actions/filterCarsActions";

const mapStateToProps = (state) => ({
  dataStateFilterCars: state.filterCars.dataState,
  clearDataStateFilterCars: state.filterCars.clearDataState,
  filterCarsListItems: get(state, ["filterCars", "filterItems"], {}),
});

const mapDispatchToProps = {
  onHandleChangeStore,
  onHandleClearFilter,
  onConfirmCarsFilter,
};

const withFilterCars = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withFilterCars };
